import safeFetch from '../../utils/safeFetch';

const checkLoginWithUrl = (url) => {
  return new Promise((resolve, reject) => {
    safeFetch(url, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        const jsonResponse = JSON.parse(data);
        if (jsonResponse.message) {
          resolve({
            isLoggedIn: jsonResponse.message.isLoggedIn,
            discount: jsonResponse.message.discount,
            typesExcludedDiscount: jsonResponse.message.typesExcludedDiscount,
          });
        } else {
          resolve({
            isLoggedIn: data,
            discount: 0,
            typesExcludedDiscount: '',
          });
        }
      })
      .catch((error) => reject(error));
  });
};

export default checkLoginWithUrl;
